var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-container"},[_c('h2',{staticClass:"subtitle"},[_vm._v(" "+_vm._s(_vm.$t('map.helpText'))+" ")]),_c('MapPoints',{attrs:{"lanterns":_vm.lanterns}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }